import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebookF, FaTwitter, FaLinkedinIn, FaEnvelope, FaPhoneAlt, FaMapMarkerAlt, FaChevronRight } from 'react-icons/fa';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section footer-section-about">
            <h3 className="footer-logo">NCAMST <span>2026</span></h3>
            <p className="footer-section-text">National Conference on Advanced Materials for Sustainable Technologies (NCAMST-2026). Organized by the Department of Sciences, IIITDM Kurnool.</p>
            <div className="footer-social-icons">
              <a href="#" className="footer-social-icon" aria-label="Facebook"><FaFacebookF /></a>
              <a href="#" className="footer-social-icon" aria-label="Twitter"><FaTwitter /></a>
              <a href="#" className="footer-social-icon" aria-label="LinkedIn"><FaLinkedinIn /></a>
            </div>
          </div>
          
          <div className="footer-section footer-section-links">
            <h4 className="footer-section-title">Quick Links</h4>
            <ul className="footer-links-list">
              <li className="footer-link-item"><Link to="/" className="footer-link"><FaChevronRight className="footer-link-icon" /> Home</Link></li>
              <li className="footer-link-item"><Link to="/committees" className="footer-link"><FaChevronRight className="footer-link-icon" /> Committees</Link></li>
              <li className="footer-link-item"><Link to="/speakers" className="footer-link"><FaChevronRight className="footer-link-icon" /> Speakers</Link></li>
              <li className="footer-link-item"><Link to="/registration" className="footer-link"><FaChevronRight className="footer-link-icon" /> Registration</Link></li>
              <li className="footer-link-item"><Link to="/contact" className="footer-link"><FaChevronRight className="footer-link-icon" /> Contact</Link></li>
            </ul>
          </div>
          
          <div className="footer-section footer-section-contact">
            <h4 className="footer-section-title">Contact Info</h4>
            <div className="footer-contact-item">
              <FaEnvelope className="footer-contact-icon" />
              <span>ncamst2026@iiitk.ac.in</span>
            </div>
            <div className="footer-contact-item">
              <FaPhoneAlt className="footer-contact-icon" />
              <span>+91-8518-289122/240</span>
            </div>
            <div className="footer-contact-item">
              <FaMapMarkerAlt className="footer-contact-icon" />
              <span>IIITDM Kurnool, Jagannathagattu Hill, Kurnool, Andhra Pradesh-518008, India</span>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <div className="footer-bottom-container">
          <p className="footer-copyright">&copy;NCAMST 2026 Conference - Department of Sciences, IIITDM Kurnool. All Rights Reserved</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
